import React, { PureComponent } from 'react';
import PassengerItem from './passengeritem';
import { connect } from 'react-redux';
import _forEach from 'lodash/forEach';


class PassengerItemContainer extends PureComponent {

  componentDidMount(){

    //Toggle material design active state
    _forEach(document.querySelectorAll('.passenger-item input'), item => {
      setTimeout(() => { if(item.value !== "") item.parentElement.parentElement.classList.add('hovered'); } ,180);
    });

  }

  render(){
    return (
      <PassengerItem {...this.props}/>
    )
  }
}

function mapStateToProps(state, props) {
  return {
    form: props.index,
  };
}

export default connect(mapStateToProps)(PassengerItemContainer);



// WEBPACK FOOTER //
// ./src/components/confirmation/components/passengeritemcontainer.js